export default __webpack_public_path__ + "static/media/long_active.8a037ed6.svg";